// US phone handling: store digits, display as (816) 223-7452.

export const phoneDigits = (v: unknown) =>
  String(v ?? "").replace(/\D/g, "").replace(/^1(?=\d{10}$)/, "").slice(0, 10);

/** Format for display and for live entry: (816) 223-7452 */
export const formatUsPhone = (v: unknown) => {
  const d = phoneDigits(v);
  if (!d) return "";
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

export const isCompleteUsPhone = (v: unknown) => phoneDigits(v).length === 10;
